export default "__VITE_ASSET__2a5f0e98__"